"use strict";

exports._ = exports._array_with_holes = _array_with_holes;
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
